// src/widgets/SetMemory.tsx
import { useTool } from '../contexts/ToolContext';
import './SetMemoryWidget.scss';

interface SetMemoryWidgetProps {

}

export const SetMemoryWidget: React.FC<SetMemoryWidgetProps> = ({

}) => {

  const { memoryKeyValue } = useTool()

  return (
    <div className="set-memory-widget">
      <div className="widget-title">set_memory()</div>
      <div className="set-memory-container">
        {Object.keys(memoryKeyValue).map((key) => (
          <p key={key}>
            <strong>{key}</strong> <span>&#8212;</span> {memoryKeyValue[key]}
          </p>
        ))}
      </div>
    </div>
  );
};